
  import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
  import Util from '@/lib/util';
  import AbpBase from '@/lib/abpbase';
  import * as proxy from '@/lib/service-proxies/service-proxies';
  import AppConsts from '@/lib/appconst';
  import PagedFilterAndSortedRequest from '@/store/entities/page-request';
  import pagelist from '@/components/pagelistcomponent';
  @Component({
    components: {  }
  })
  export default class suppliermanage extends pagelist {
    get prox() {
      return new proxy.MerchantDayBillServiceProxy();
    }
    input: proxy.MerchantDayBillPageInputDto = new proxy.MerchantDayBillPageInputDto();
    sub_id = 0;
    createOrEditShow = false;
    BalanceTypes=[];
    createrange=[];
    totalOrderNum = 0;
    totalAmount = 0;
    commission = 0;
    totalpayMoney = 0;
    columns = [
      {
        type: 'selection',
        width: 60,
        align: 'center'
      },
      
     
      {
          title:'总成功金额',
          key:'money'
      },
      {
        title:'总成功笔数',
        key:'orderNum'
      },
      {
        title:'服务费',
        key:'commission'
      },
      {
        title:'实收金额',
        key:'payMoney'
      },
    {
        title:'结算时间',
        key:'settlementTimeStr'
    },
      {
        title: '创建时间',
        key: 'creationTime',
        width:180
      }
    ];
    exportrecord(){
    var ids = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.input.ids = ids;
    this.prox.export(this.input).then((x) => {
      location.href =
        AppConsts.remoteServiceBaseUrl +
        '/File/DownloadTempFile?FileToken=' +
        x.fileToken +
        '&fileName=' +
        x.fileName +
        '&fileType=' +
        x.fileType;
    });
  }
    fetchDataList(
      request: PagedFilterAndSortedRequest,
      pageNumber: number,
      finishedCallback: Function
    ): void {
      this.input.skipCount = request.skipCount;
      this.input.maxResultCount = request.maxResultCount;
      this.input.sorting = request.sorting;
      this.input.createStartTime=this.createrange[0];
      this.input.createEndTime=this.createrange[1];
      this.prox.queryModelList(this.input).then(x => {
        this.dataList = x.items;
        let _totalOrderNum = 0, _totalAmount = 0, _commission = 0,_totalpayMoney=0;
        this.dataList.map(p => {
        _totalOrderNum += p.orderNum;
        _totalAmount += p.money;
        _commission += p.commission;
        _totalpayMoney += p.payMoney;
       })
       this.totalOrderNum = _totalOrderNum;
      this.totalAmount = _totalAmount;
      this.commission = _commission;
      this.totalpayMoney = _totalpayMoney;
        this.showPaging(x);
      });
    }
     
    getpage() {
      this.OnInit();
    }
    async created() {
 
      new proxy.CommonServiceProxy().getEnumKeyValue('BalanceTypeEnum').then(x => {
      this.BalanceTypes = x;
    })
      this.getpage();
    }
    
  }
  